<template>
    <v-card>
        <v-card-title>
            Calendario
        </v-card-title>
        <v-card-text>

            <v-simple-table>
                    <tbody>
                        <tr>
                            <td>
                                <v-autocomplete
                                    label="Mese"
                                    v-model="calendar.month"
                                    :items="months"
                                    item-text="text"
                                    item-value="number"
                                    :loading="loading"
                                    :rules="rules.month"
                                >
                            </v-autocomplete>
                            </td>

                            <td>
                                <v-text-field
                                    label="Anno"
                                    v-model="calendar.year"
                                    type="number"
                                    :loading="loading"
                                    :rules="rules.year"
                                >
                                </v-text-field>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>


            <v-calendar
                :events="calendar.days"
                :now="calendar.dayWorkResource.date"
                :weekdays="calendar.week_days"
                :end="calendar.end"
                :start="calendar.start"
                locale="it"
                @click:day="dayClicked"
                @click:date="dayClicked"
                @contextmenu:date="dayClicked"
                :class="[$style.calendar]"
                color='grey lighten-1'
            >
            </v-calendar>

        </v-card-text>
    </v-card>
</template>
<script>
export default {
    name: "TimesheetCalendar",
    props: {
        dailyWorkResource: {
            type: Object,
            required: true
        },
        workLogs: {
            type: Array,
            required: true
        },
    },
    data(){
        let calendar = {
            dayWorkResource: this.dailyWorkResource,
            month: 1,
            year: 2024,
            week_days: [1, 2, 3, 4, 5, 6, 0],
            end: "2024-01-31",
            start: "2024-01-01",
            days: [],
        };
        return {
            calendar,
            months:[],
            error:null,
            message:null,
            loading:false,
            rules: {
                month: [
                    (v) => (!!v && parseInt(v) != NaN && v >= 1 && v <= 12) || "Il mese non è valido"
                ],
                year: [
                    (v) => (!!v && parseInt(v) != NaN && v >= 1970 && v <= 3000) || "L'anno non è valido"
                ],
            }

        };
    },
    mounted: function () {
        this.setupCalendar();
    },
    methods:{
        getMonth(date) {
            let m = null;
            if(this.isValidDate(date)) {
                let dateArr = date.split("-");
                m = parseInt(dateArr[1]);
            }
            return m;
        },
        getYear(date) {
            let y = null;
            if(this.isValidDate(date)) {
                let dateArr = date.split("-");
                y = parseInt(dateArr[0]);
            }
            return y;
        },
        dayClicked(day) {
            if(this.isValidDate(day.date)) {
                this.calendar.dayWorkResource.date = day.date;
                this.$emit('changeDate', day.date);
            }
        },
        setupCalendar() {
            this.months = this.getListMonths();

            if(this.isValidDate(this.calendar.dayWorkResource.date)) {
                this.calendar.year  = this.getSelectYear();
                this.calendar.month = this.getMonth(this.calendar.dayWorkResource.date);
                this.calendar.start = this.getFirstDayMonth();
                this.calendar.end   = this.getLastDayMonth();
            }
        },
        getFirstDayMonth () {
            let day = null;

            day = this.getSelectYear() + "-" + this.getMonth(this.calendar.dayWorkResource.date) + "-" + "01";

            return day;
        },
        getLastDayMonth () {
            let day = "";

            day = this.getSelectYear() + "-" + this.getMonth(this.calendar.dayWorkResource.date) + "-" + new Date(this.getSelectYear(), this.getMonth(this.calendar.dayWorkResource.date), 0).getDate();

            return day;
        },
        isItWeekendDay(day) {
            let response = false;

            try {
                let date = new Date(day);
                if(date.getDay() === 6 || date.getDay() === 0) {
                    response = true;
                }
            }
            catch(e) {
                console.log("Error: " + e);
            }
            return response;
        },
        areThereWorkingHoursOnThisDay(day, list) {
            let response = false;

            try {
                for(let i = 0; i < list.length; i++) {
                    let date_1 = list[i].date.split("-");
                    let date_2 = day.split("-");

                    if(parseInt(date_1[0]) === parseInt(date_2[0]) && parseInt(date_1[1]) === parseInt(date_2[1]) && parseInt(date_1[2]) === parseInt(date_2[2]) &&  list[i].time > 0) {
                        response = true;
                        break;
                    }
                }
            }
            catch(e) {
                console.log("Error: " + e);
            }

            return response;
        },
        isValidDate(date) {
            return (/^\d{4}-\d{2}-\d{2}$/.test(date) && !isNaN(Date.parse(date.trim())));
        },
        getListMonths() {
            return [
                {
                    number:1,
                    text:"Gennaio"
                },
                {
                    number:2,
                    text:"Febbraio"
                },
                {
                    number:3,
                    text:"Marzo"
                },
                {
                    number:4,
                    text:"Aprile"
                },
                {
                    number:5,
                    text:"Maggio"
                },
                {
                    number:6,
                    text:"Giugno"
                },
                {
                    number:7,
                    text:"Luglio"
                },
                {
                    number:8,
                    text:"Agosto"
                },
                {
                    number:9,
                    text:"Settembre"
                },
                {
                    number:10,
                    text:"Ottobre"
                },
                {
                    number:11,
                    text:"Novembre"
                },
                {
                    number:12,
                    text:"Dicembre"
                },
            ]
        },
        setSelectDay() {
            if(this.calendar.year !== isNaN && this.calendar.year >= 1970 && this.calendar.year <= 3000 && this.calendar.month !== isNaN && this.calendar.month >= 1 && this.calendar.month <= 12) {
                this.calendar.dayWorkResource.date = this.calendar.year + "-" + (this.calendar.month <= 9 ? "0" + this.calendar.month : this.calendar.month) + "-" + "01";
            }
        },
        getSelectMonth() {
            let month_selected = this.getMonth(this.calendar.dayWorkResource.date);
            return month_selected;
        },
        getSelectYear() {
            let year_selected = this.getYear(this.calendar.dayWorkResource.date);
            return year_selected;
        },
        getItalianHolidays() {
            let year = this.getSelectYear();
            const holidays = [];

            holidays.push(year + '-1-1');
            holidays.push(year + '-1-6');
            let pasqua = this.easter_date(year);
            holidays.push(pasqua[0]);
            holidays.push(pasqua[1]);
            holidays.push(year + '-4-25');
            holidays.push(year + '-5-1');
            holidays.push(year + '-6-2');
            holidays.push(year + '-8-15');
            holidays.push(year + '-11-1');
            holidays.push(year + '-12-8');
            holidays.push(year + '-12-25');
            holidays.push(year + '-12-26');

            return holidays;
        },
        easter_date(year = null) {
            if (year === null) {
                year = new Date().getFullYear();
            }

            const a = year % 19;
            const b = Math.floor(year / 100);
            const c = year % 100;
            const d = Math.floor(b / 4);
            const e = b % 4;
            const f = Math.floor((b + 8) / 25);
            const g = Math.floor((b - f + 1) / 3);
            const h = (19 * a + b - d - g + 15) % 30;
            const i = Math.floor(c / 4);
            const k = c % 4;
            const l = (32 + 2 * e + 2 * i - h - k) % 7;
            const m = Math.floor((a + 11 * h + 22 * l) / 451);
            const month = Math.floor((h + l - 7 * m + 114) / 31);
            const day = ((h + l - 7 * m + 114) % 31) + 1;

            const pasqua = (year + '-' + month + '-' + day)

            const date = new Date(pasqua);
            date.setDate(date.getDate() + 1);

            const year2 = date.getFullYear();
            const month2 = date.getMonth() + 1;
            const day2 = date.getDate();

            const pasquetta = `${year2}-${month2}-${day2}`;

            return [pasqua, pasquetta];
        },
    },
    watch: {
        'calendar.dayWorkResource.date': function () {
            if(this.calendar && this.calendar.year && this.calendar.month && (this.calendar.year != this.getSelectYear() || this.calendar.month != this.getSelectMonth())) {
                this.setupCalendar();
            }
        },
        'calendar.dayWorkResource.user': function () {
            if(this.calendar && this.calendar.dayWorkResource && this.calendar.dayWorkResource.user) {
                this.setupCalendar();
            }
        },
        'calendar.dayWorkResource.reload_calendar': function () {
            this.setupCalendar();
        },
        'calendar.year': function() {
            if(this.calendar.month && this.calendar.year && this.calendar.year != this.getSelectYear()) {
                this.setSelectDay();
                this.setupCalendar();
            }
        },
        'calendar.month': function() {
            if(this.calendar.month && this.calendar.year && this.calendar.month != this.getSelectMonth()) {
                this.setSelectDay();
                this.setupCalendar();
            }
        },
    },
}
</script>
<style module>
.calendar{
        text-align: center;
};
</style>
